import React from 'react';
import { Col, Container, Row, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const QuestionOptions = ({values, handleChange, setFieldValue, errors}) => {

  const { surveyTemplate } = useSelector(state => state.surveyTemplate);
  const { surveyTemplateQuestions: questions } = useSelector(state => state.surveyTemplateQuestions);

  const getTriggerOptions = () => {
    return questions.flatMap((question) =>
      question?.answers?.map((answer) => (
        <option 
          key={`${question.id}-${answer.id}`} 
          value={JSON.stringify([question.id, answer.id])}
        >
          {question.description} / {answer.description}
        </option>
      ))
    );
  };

  const onRequiredAnswerChange = (e, setFieldValue) => {
    setFieldValue('isRequiredAnswer', e.target.checked);
    if (!e.target.checked) {
      setFieldValue('errorMessage', '');
    }
  }
  

  return (
    <Container>
      <Row className="mt-4">
        <Col xs={12} md={6}>
          <h6>Respuestas</h6>
          <hr className="mb-4" />
          {
            values.questionType === 'Opción múltiple: solo una respuesta' || 
            values.questionType === 'Opción múltiple: se permiten varias respuestas' ? (
              <>
                <Form.Group className="invisible">
                  <Form.Row className="mb-1">
                    <Col md={4}>
                      <Form.Label className="font-weight-bold">Mostrar campo de comentario</Form.Label>
                    </Col>
                    <Col md={8}>
                      <Form.Check
                        type="checkbox"
                        name="showFieldComment"
                        onChange={(e) => setFieldValue('showFieldComment', e.target.checked)} 
                        defaultChecked={values.showFieldComment} />
                    </Col>
                  </Form.Row>
                </Form.Group>
                {
                  values.showFieldComment && (
                    <> 
                      <Form.Group className="invisible">
                        <Form.Row>
                          <Col md={4}>
                          <Form.Label className="font-weight-bold">Mensaje del comentario</Form.Label>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              className="rounded-pill"
                              size="sm"
                              type="text"
                              name="messageComment"
                              placeholder="Ingrese el comentario"
                              value={values.messageComment}
                              onChange={handleChange}
                              isInvalid={errors.messageComment} />
                            <Form.Control.Feedback type="invalid" className="ml-2">
                              {errors.messageComment}
                            </Form.Control.Feedback>
                          </Col>
                        </Form.Row>
                      </Form.Group>
                      <Form.Group className="invisible">
                      <Form.Row className="mb-1">
                        <Col md={4}>
                          <Form.Label className="font-weight-bold">¿El comentario es una respuesta?</Form.Label>
                        </Col>
                          <Col md={8}>
                            <Form.Check
                              type="checkbox"
                              name="isCommentAnswer"
                              onChange={(e) => setFieldValue('isCommentAnswer', e.target.checked)} 
                              defaultChecked={values.isCommentAnswer} />
                          </Col>
                        </Form.Row>
                      </Form.Group>
                    </>
                  )
                }
              </>
            ) : null
          }
          {
            values.questionType === 'Cuadro de texto de una línea' ||
            values.questionType === 'Valor numérico' ||
            values.questionType === 'Fecha' ||
            values.questionType === 'Fecha y hora' ? (
              <>
                <Form.Group>
                  <Form.Row>
                    <Col md={4}>
                      <Form.Label className="font-weight-bold">¿Requiere validación de entrada?</Form.Label>
                    </Col>
                    <Col md={8}>
                      <Form.Check
                        type="checkbox"
                        name="requiredValidInput"
                        onChange={(e) => setFieldValue('requiredValidInput', e.target.checked)} 
                        defaultChecked={values.requiredValidInput} />
                    </Col>
                  </Form.Row>
                </Form.Group>
                {
                  values.requiredValidInput && (
                    <>
                      <Form.Group>
                        <Form.Row>
                          <Col md={4}>
                            <Form.Label className="font-weight-bold">Valor mínimo</Form.Label>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              className="rounded-pill"
                              size='sm'
                              type={values.questionType === 'Valor numérico' ? 'number' : values.questionType === 'Fecha' ? 'date' : values.questionType === 'Fecha y hora' ? 'datetime-local' : 'text'}
                              name="min"
                              placeholder="Ingrese el valor mínimo"
                              value={values.min}
                              onChange={handleChange}
                              isInvalid={errors.min} />
                            <Form.Control.Feedback type="invalid" className="ml-2">
                              {errors.min}
                            </Form.Control.Feedback>
                          </Col>
                        </Form.Row>
                      </Form.Group>
                      <Form.Group>
                        <Form.Row>
                          <Col md={4}>
                            <Form.Label className="font-weight-bold">Valor máximo</Form.Label>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              className="rounded-pill"
                              size='sm'
                              type={values.questionType === 'Valor numérico' ? 'number' : values.questionType === 'Fecha' ? 'date' : values.questionType === 'Fecha y hora' ? 'datetime-local' : 'text'}
                              name="max"
                              placeholder="Ingrese el valor máximo"
                              value={values.max}
                              onChange={handleChange}
                              isInvalid={errors.max} />
                            <Form.Control.Feedback type="invalid" className="ml-2">
                              {errors.max}
                            </Form.Control.Feedback> 
                          </Col>
                        </Form.Row>
                      </Form.Group>
                      <Form.Group>
                        <Form.Row>
                          <Col md={4}>
                            <Form.Label className="font-weight-bold">Mensaje de error</Form.Label>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              className="rounded-pill"
                              size='sm'
                              type="text"
                              name="validationError"
                              placeholder="Ingrese el mensaje de error"
                              value={values.validationError}
                              onChange={handleChange}
                              isInvalid={errors.validationError} />
                            <Form.Control.Feedback type="invalid" className="ml-2">
                              {errors.validationError}
                            </Form.Control.Feedback>
                          </Col>
                        </Form.Row>
                      </Form.Group>
                    </>
                  )
                }
              </>
            ) : null
          }
          {
            values.questionType === 'Cuadro de texto con varias líneas' ||
            values.questionType === 'Cuadro de texto de una línea' ||
            values.questionType === 'Valor numérico' ||
            values.questionType === 'Fecha' ||
            values.questionType === 'Fecha y hora' ? (
              <Form.Group className="invisible">
                <Form.Row>
                  <Col md={4}>
                    <Form.Label className="font-weight-bold">Marcador de posición</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      className="rounded-pill"
                      size='sm'
                      type="text"
                      name="helperText"
                      placeholder="Ingrese el mensaje de error"
                      value={values.helperText}
                      onChange={handleChange}
                      isInvalid={errors.helperText} />
                    <Form.Control.Feedback type="invalid" className="ml-2">
                      {errors.helperText}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Row>
              </Form.Group>
            ) : null
          }
          <h6>Restriciones</h6>
          <hr className="mb-4" />
          <Form.Group>
            <Form.Row>
              <Col md={4}>
                <Form.Label className="font-weight-bold">¿Respuesta requerida?</Form.Label>
              </Col>
              <Col md={8}>
                <Form.Check
                  type="checkbox"
                  name="isRequiredAnswer"
                  onChange={(e) => onRequiredAnswerChange(e, setFieldValue)}
                  defaultChecked={values.isRequiredAnswer} />
              </Col>
            </Form.Row>
          </Form.Group>
          {
            values.isRequiredAnswer && (
              <>
                <Form.Group>
                  <Form.Row>
                    <Col md={4}>
                      <Form.Label className="font-weight-bold">Mensaje de error</Form.Label>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        className="rounded-pill"
                        size='sm'
                        type="text"
                        name="errorMessage"
                        placeholder="Ingrese el mensaje de error"
                        value={values.errorMessage}
                        onChange={handleChange}
                        isInvalid={errors.errorMessage} />
                      <Form.Control.Feedback type="invalid" className="ml-2">
                        {errors.errorMessage}
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Row>
                </Form.Group>
              </>
            )
          }
        </Col>
        <Col xs={12} md={6}>
          <h6>Visualización condicional</h6>
          <hr className="mb-4" />
          {
            surveyTemplate.survey_type === 'Evaluación' && (
              <Form.Group>
                <Form.Row>
                  <Col md={4}>
                    <Form.Label className="font-weight-bold">Puntuación</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      className="rounded-pill"
                      size='sm'
                      type="text"
                      name="score"
                      placeholder="Ingrese el mensaje de error"
                      value={values.score}
                      onChange={handleChange}
                      isInvalid={errors.score} />
                    <Form.Control.Feedback type="invalid" className="ml-2">
                      {errors.score}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Row>
              </Form.Group>
            )
          }
          <Form.Group className='invisible'>
            <Form.Row>
              <Col xs={12} md={4}>
                <Form.Label className="font-weight-bold">Respuestas desencadenantes</Form.Label>
              </Col>
              <Col xs={12} md={8}>
                <Form.Control 
                  as="select" 
                  name="triggerAnswer"
                  className="rounded-pill"
                  size="sm"
                  onChange={handleChange}
                  value={values.triggerAnswer}
                  isInvalid={errors.triggerAnswer}>
                    <option value="">Selecciona una respuesta</option>
                    {
                      getTriggerOptions()
                    }
                  </Form.Control>
                  <Form.Control.Feedback type="invalid" className="ml-2">
                    {errors.triggerAnswer}
                  </Form.Control.Feedback>
              </Col>
            </Form.Row>
          </Form.Group>
        </Col>
      </Row>
    </Container>
  )
}

export default QuestionOptions;